import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default ({ className }) => (
  <SvgIcon viewBox='0 0 9.414 9.414' className={className} style={{ height: 9, width: 9 }}>
    <g id='Сгруппировать_2699' data-name='Сгруппировать 2699' transform='translate(-16361.951 1699.207)'>
      <path
        id='Контур_13775'
        data-name='Контур 13775'
        d='M0,0,4,4,8,0'
        transform='translate(16370.658 -1690.5) rotate(180)'
        fill='none'
        stroke='#8a949f'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1'
      />
      <path
        id='Контур_13776'
        data-name='Контур 13776'
        d='M0,4,4,0,8,4'
        transform='translate(16370.658 -1694.5) rotate(180)'
        fill='none'
        stroke='#8a949f'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1'
      />
    </g>
  </SvgIcon>
);
